/**
*  Targeting helper always checks prescence of target before manipulating classes to avoid errors
**/

export default class TargetHelper {
  constructor(controller) {
    this.controller = controller;
  }

  addClassTarget(targetName, className, multiple = false) {
    if (!isPresent(targetName)) return;

    if (multiple) {
      this.controller[`${targetName}Targets`].forEach((target) => {
        if(!target.classList.contains(className)) target.classList.add(className);
      });
    } else {
      if (!this.controller[`${targetName}Target`].classList.contains(className)){
        this.controller[`${targetName}Target`].classList.add(className);
      }
    }
  }

  removeClassTarget(targetName, className, multiple = false) {
    if (!isPresent(targetName)) return;

    if (multiple) {
      this.controller[`${targetName}Targets`].forEach((target) => {
        if (target.classList.contains(className)) target.classList.remove(className);
      });
    } else {
      this.controller[`${targetName}Target`].classList.remove(className);
    }
  }

  isPresent(targetName) {
    return this.controller[`has${targetName.capitalize()}Target`];
  }
}
